module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_ranking1.8df1b.png";